import React from 'react';
import { futureFeaturesData } from '../../data/distributorsData';
import { UserPlus, Globe, Server, ArrowRight, CheckCircle, Monitor, Database, Cloud, Palette, Shield, HardDrive, Lock, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';

const iconMap = {
  UserPlus,
  Globe,
  Server
};

const vendorIcons = {
  Microsoft: Monitor,
  Adobe: Palette,
  Acronis: Shield,
  AWS: Database,
  'Google Cloud': Cloud,
  Kaspersky: Lock,
  Sophos: ShieldCheck,
  Dropbox: HardDrive
};

const vendorColors = {
  Microsoft: '#00a4ef',
  Adobe: '#ff0000',
  Acronis: '#1297fd',
  AWS: '#ff9900',
  'Google Cloud': '#4285f4',
  Kaspersky: '#006d5c',
  Sophos: '#2d72b9',
  Dropbox: '#0061ff'
};

const FutureProofSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8bcaf9]/20 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Preparado para el Futuro
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Prepara tu negocio de distribución IT{' '}
            <span className="text-[#1297fd]">para el futuro</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-3xl mx-auto">
            Expandirte a nuevos mercados, añadir nuevos vendors y escalar debería ser sin fricciones. Con nuestra plataforma multi-tier, multi-moneda y multi-región, estarás listo para crecer con confianza.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {futureFeaturesData.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group text-center"
              >
                {/* Icon */}
                <div className="w-20 h-20 mx-auto rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-[#1297fd]/20" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  {IconComponent && <IconComponent className="w-10 h-10 text-white" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#1297fd] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-[#c3c3c5] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Vendor Logos */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-[#e3e4e6]">
          <p className="text-center text-[#c3c3c5] mb-8">Integraciones incorporadas con vendors líderes</p>
          <div className="flex flex-wrap justify-center items-center gap-5 md:gap-8">
            {['Microsoft', 'Adobe', 'Acronis', 'AWS', 'Google Cloud', 'Kaspersky', 'Sophos', 'Dropbox'].map((vendor) => {
              const IconComponent = vendorIcons[vendor];
              const color = vendorColors[vendor];
              return (
                <div
                  key={vendor}
                  className="group px-4 py-3 bg-white rounded-xl shadow-sm border border-[#e3e4e6] hover:shadow-lg hover:border-[#8bcaf9] transition-all hover:scale-105 flex items-center gap-2 cursor-pointer"
                >
                  <div 
                    className="h-8 w-8 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${color}15` }}
                  >
                    {IconComponent && <IconComponent className="h-4 w-4" style={{ color }} />}
                  </div>
                  <span className="text-gray-700 font-medium text-sm group-hover:text-[#1297fd] transition-colors">{vendor}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <Button
            size="lg"
            className="text-white font-semibold px-10 py-6 rounded-full text-lg transition-all hover:scale-105 hover:shadow-xl group"
            style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}
          >
            Comenzar ahora
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FutureProofSection;
